import { replica } from '@/shared/sync/replica';
import type { CollectionName } from './collection-name';

export async function restoreRecord(collection: CollectionName, id: string): Promise<void> {
  await replica.mutate(collection, 'restore', {}, id);
}
